export default __webpack_public_path__ + "static/media/history-2.c90f0efc.png";